import { CheckCircle } from 'lucide-react';
import { BrandingSettings } from '@/hooks/useReferentBranding';

interface SuccessStepProps {
  candidateName?: string;
  branding?: BrandingSettings | null;
}

export const SuccessStep = ({ branding }: SuccessStepProps) => {
  const primaryColor = (branding?.enabled && branding?.primaryColor) ? branding.primaryColor : '#4ECDC4';

  return (
    <div className="min-h-screen bg-gray-50 font-['Bricolage_Grotesque']">
      <div className="max-w-2xl mx-auto px-4 py-8">
        {/* Header avec logo et badge */}
        <div className="flex justify-between items-center mb-16">
          {/* Logo - Utilise le branding ou Getproof par défaut */}
          <img
            className="w-32 sm:w-40 h-auto"
            src={(branding?.enabled && branding?.logoUrl) ? branding.logoUrl : "/lovable-uploads/c941c7a1-d271-4c8b-91a4-2611677da8a6.png"}
            alt={(branding?.enabled && branding?.logoUrl) ? "Logo Entreprise" : "Getproof Logo"}
          />

          {/* Badge avec couleur de branding */}
          <div
            className="px-3 py-1.5 rounded-md border text-sm font-medium"
            style={{
              borderColor: primaryColor,
              color: primaryColor
            }}
          >
            Formulaire De Référence
          </div>
        </div>

        {/* Contenu principal centré */}
        <div className="text-center space-y-8">
          {/* Icône de succès */}
          <div className="flex justify-center">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center"
              style={{ backgroundColor: primaryColor }}
            >
              <CheckCircle className="h-8 w-8 text-white" />
            </div>
          </div>

          {/* Titre et sous-titre */}
          <div className="space-y-3">
            <h1 className="text-4xl font-semibold text-gray-900">
              Merci
            </h1>
            <p className="text-lg text-gray-500">
              Votre réponse a été soumise avec succès.
            </p>
          </div>

          {/* Section informative */}
          <div className="max-w-lg mx-auto">
            <div
              className="bg-gray-50 border-l-4 p-6 rounded-r-lg text-left"
              style={{ borderLeftColor: primaryColor }}
            >
              <h3 className="text-base font-medium text-gray-900 mb-3">
                Que se passe-t-il ensuite ?
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Le candidat sera informé de votre soumission et sa candidature progressera dans le processus.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 text-center space-y-4">
          <p className="text-xs text-gray-400 leading-relaxed max-w-md mx-auto">
            Cette demande de référence est effectuée conformément à la législation en vigueur.
            Vos réponses sont confidentielles et traitées conformément au RGPD.
          </p>
          <p
            className="text-sm font-medium"
            style={{ color: primaryColor }}
          >
            L'équipe Getproof
          </p>
        </div>
      </div>
    </div>
  );
};